import React from "react";
import { Helmet } from "react-helmet-async";
import {
  SITE_URL,
  SITE_NAME,
  DEFAULT_OG_IMAGE,
  DEFAULT_DESCRIPTION,
  getPageSeo,
} from "./seoConfig";

// Per-route SEO: title, description, canonical, Open Graph, Twitter/X, and robots.
// Note: JS-rendering crawlers (Google) read these; non-JS social crawlers
// (Facebook, LinkedIn, Slack, iMessage) read the static tags in public/index.html.
export const SEO = ({ pathname }) => {
  const page = getPageSeo(pathname);
  const url = `${SITE_URL}${pathname === "/" ? "" : pathname}`;
  const title = page.title;
  const description = page.description || DEFAULT_DESCRIPTION;
  const image = page.image || DEFAULT_OG_IMAGE;

  return (
    <Helmet prioritizeSeoTags>
      <html lang="en" />
      <title>{title}</title>
      <meta name="description" content={description} />
      {page.keywords && <meta name="keywords" content={page.keywords} />}
      <link rel="canonical" href={url} />
      {page.noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow, max-image-preview:large" />
      )}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content="Girls in pink AGG branded shirts smiling together" />
      <meta property="og:locale" content="en_US" />

      {/* Twitter / X */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
